enum DocTypeEnum {
    Full = 'FULL',
    Low = 'LOW',
    No = 'NO',
}

export default DocTypeEnum;
